import{createSlice, PayloadAction} from "@reduxjs/toolkit";

interface CompanyInfoState{
    comapnyInfo: any|null;
}

const initialState: CompanyInfoState={
    comapnyInfo: null,

}

const companySlice= createSlice({
    name:"company",
    initialState,
    reducers:{
        setCompanyInfo:(state, action:PayloadAction<any>)=>{
            state.comapnyInfo = action.payload;
        },
    },
});

export const {setCompanyInfo}= companySlice.actions;
export default companySlice.reducer;